// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__6oQlB"};